import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { UserService } from "@/modules/User/services/UserService";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { Http } from "@status/codes";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { NotificationTemplateServices } from "@/modules/NotificationTemplate/services/NotificationTemplateService";

export class NotificationsPropertiesValues extends ListOfPropertiesValues {
  createdBy = this.findUsers;
  changedBy = this.findUsers;
  user = this.findUsers;
  messageTemplate = this.findWsTemplates;

  indexCollection = 0;
  indexSectionOfDashboard = 0;
  keyword = "";
  lastRef = "";
  lastDocId = "";

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof NotificationsPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof NotificationsPropertiesValues]();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async findUsers(name?: string) {
    try {
      if (!name) return [];

      const filterQuery = this.setFilters(
        GENERAL_RULES_CONSTANTS.ID_REFERENCE,
        name
      );

      const userService = new UserService();
      const responseUsers = await userService.getUserByFilters(
        filterQuery as UserQuery
      );

      if (responseUsers.code === Http.Found) {
        this.lastRef = responseUsers.data?.lastReference!;
        const userList: DynamicSelectData[] = [];
        responseUsers.data?.userArray.forEach(user => {
          userList.push({
            id: user.name!,
            name: user.name!
          });
        });
        userList.push(FIELD_WITHOUT_DATA);
        return {
          data: responseUsers.data?.userArray.map(user => ({
            id: user.name,
            name: user.name
          }))
        };
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }

  async findWsTemplates() {
    try {
      const notificationTemplateService = new NotificationTemplateServices();
      const response = await notificationTemplateService.filterTemplates();

      if (
        response.code === Http.Found &&
        response.data &&
        response.data.templates
      ) {
        const templatesList: DynamicSelectData[] = [];
        response.data.templates.forEach(({ id, name }) => {
          templatesList.push({
            id: id as string,
            name: name || ""
          });
        });
        templatesList.push(FIELD_WITHOUT_DATA);
        return { data: templatesList };
      }
      return { data: [] };
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return { data: [] };
    }
  }
}
